import React from 'react';
import PropTypes from 'prop-types';

/**
 * StatusIcon Component
 * 
 * Renders the single tick icon from Figma for all WhatsApp message statuses
 * Following exact Figma design specifications: "Tick 1" icon component
 * Dimensions: 17x17px, Color: Blue Grey 100 (#CFD8DC)
 */
const StatusIcon = ({ status, className, style }) => {
  // Single tick icon from Figma - "Tick 1" component (505:4558)
  // Used for all message statuses as per design requirements
  return (
    <svg 
      width="17" 
      height="17" 
      viewBox="0 0 17 17" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      {/* Vector positioned at (1.42, 1.42) with dimensions 14.17x14.17 as per Figma */}
      <path
        d="M6.5 8.5L8.5 10.5L15 4"
        stroke="#CFD8DC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(1.42, 1.42)"
      />
    </svg>
  );
};

StatusIcon.propTypes = {
  status: PropTypes.oneOf(['sent', 'delivered', 'read', 'failed', 'pending']), // Status parameter kept for API compatibility but not used in rendering
  className: PropTypes.string,
  style: PropTypes.object
};

StatusIcon.defaultProps = {
  status: 'sent',
  className: '',
  style: {}
};

export default StatusIcon;